import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, Transition as _Transition, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, Teleport as _Teleport, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "call-header-identity" }
const _hoisted_2 = { class: "call-header-avatar" }
const _hoisted_3 = {
  key: 0,
  class: "call-header-initials"
}
const _hoisted_4 = { class: "call-header-text" }
const _hoisted_5 = { class: "call-header-name" }
const _hoisted_6 = { class: "call-header-subtitle" }
const _hoisted_7 = { class: "call-header-subtitle-text" }
const _hoisted_8 = { class: "call-header-actions" }
const _hoisted_9 = {
  type: "button",
  class: "header-icon-btn drag-handle",
  title: "Drag to move"
}
const _hoisted_10 = { class: "call-body" }
const _hoisted_11 = {
  key: 0,
  class: "incoming-call-section"
}
const _hoisted_12 = { class: "incoming-call-header" }
const _hoisted_13 = { class: "incoming-call-from" }
const _hoisted_14 = { class: "incoming-call-actions" }
const _hoisted_15 = {
  key: 1,
  class: "active-incoming-call-section"
}
const _hoisted_16 = { class: "active-call-header" }
const _hoisted_17 = { class: "active-call-timer" }
const _hoisted_18 = { class: "active-call-actions" }
const _hoisted_19 = {
  key: 0,
  class: "incoming-call-caption-box"
}
const _hoisted_20 = {
  key: 2,
  class: "ai-call-prompt-overlay"
}
const _hoisted_21 = { class: "ai-call-prompt-card" }
const _hoisted_22 = { class: "ai-call-prompt-header" }
const _hoisted_23 = { class: "ai-call-prompt-loading" }
const _hoisted_24 = { class: "ai-call-prompt-header" }
const _hoisted_25 = {
  key: 0,
  class: "ai-call-prompt-icp-selection"
}
const _hoisted_26 = { class: "ai-call-prompt-actions" }
const _hoisted_27 = {
  key: 3,
  class: "active-call-container"
}
const _hoisted_28 = {
  key: 0,
  class: "ai-suggestion-bubble"
}
const _hoisted_29 = { class: "suggestion-header" }
const _hoisted_30 = { class: "header-left" }
const _hoisted_31 = { class: "robot-icon-wrapper" }
const _hoisted_32 = { class: "suggestion-text" }
const _hoisted_33 = {
  key: 0,
  class: "suggestion-item is-latest"
}
const _hoisted_34 = { class: "suggestion-text" }
const _hoisted_35 = {
  key: 1,
  class: "thinking-item"
}
const _hoisted_36 = {
  key: 0,
  class: "live-caption-container-box"
}
const _hoisted_37 = { class: "call-controls-row" }
const _hoisted_38 = { class: "control-item-original" }
const _hoisted_39 = {
  class: "control-item-original",
  style: {"position":"relative"}
}
const _hoisted_40 = {
  class: "control-item-original",
  style: {"position":"relative"}
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  class: "control-item-original",
  style: {"position":"relative"}
}
const _hoisted_43 = { class: "keypad-popover-header" }
const _hoisted_44 = { class: "keypad-grid" }
const _hoisted_45 = { class: "transfer-popover__header" }

import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from "vue";
import { Icon } from "@iconify/vue";
import LiveCaption from "@/components/call/LiveCaption.vue";
import Button from "@/components/ui/Button.vue";
import Spinner from "@/components/ui/Spinner.vue";
import Select from "@/components/ui/Select.vue";

interface Props {
  show: boolean;
  contactName?: string;
  to?: string;
  status: string;
  isPreparingAIContext: boolean;
  showAIPrompt: boolean;
  incomingCallData: any;
  formattedIncomingCallTimer: string;
  formattedCallTimer: string;
  isMuted: boolean;
  saveRecording: boolean;
  enableTranscription: boolean;
  parentCallSid: string | null;
  currentCallSid: string | null;
  account: any;
  microphones: any[];
  speakers?: any[];
  selectedMicId?: string;
  selectedSpeakerId?: string;
  isThinking: boolean;
  isStreaming: boolean;
  hasSuggestions: boolean;
  currentStreamingText: string;
  aiSuggestions?: any[];
  icps?: any[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CallSessionModal',
  props: {
    show: { type: Boolean, default: false },
    contactName: {},
    to: {},
    status: {},
    isPreparingAIContext: { type: Boolean },
    showAIPrompt: { type: Boolean },
    incomingCallData: {},
    formattedIncomingCallTimer: {},
    formattedCallTimer: {},
    isMuted: { type: Boolean },
    saveRecording: { type: Boolean },
    enableTranscription: { type: Boolean },
    parentCallSid: {},
    currentCallSid: {},
    account: {},
    microphones: {},
    speakers: { default: () => [] },
    selectedMicId: { default: "" },
    selectedSpeakerId: { default: "" },
    isThinking: { type: Boolean },
    isStreaming: { type: Boolean },
    hasSuggestions: { type: Boolean },
    currentStreamingText: {},
    aiSuggestions: {},
    icps: { default: () => [] }
  },
  emits: ["close", "proceed-with-ai", "proceed-without-ai", "answer-incoming-call", "decline-incoming-call", "hangup-incoming-call", "hangup", "toggle-record", "toggle-mute", "transfer-call", "select-microphone", "select-speaker", "send-digit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const activeCallStates = computed(() => ["connecting", "ringing", "in-call", "reconnecting"]);

// Ringtone for the incoming-call-from-a-known-contact section above — this
// modal previously had no sound at all while ringing.
const RINGING_SOUND_URL = new URL("../../assets/audio/ringing-new.m4a", import.meta.url).href;
const audioRef = ref<HTMLAudioElement | null>(null);

const initAudio = () => {
  if (audioRef.value) return;
  try {
    audioRef.value = new Audio(RINGING_SOUND_URL);
    audioRef.value.loop = true;
    audioRef.value.volume = 0.7;
  } catch (error) {
    console.error("Failed to initialize ringtone audio:", error);
  }
};

const playRingingSound = async () => {
  if (!audioRef.value) initAudio();
  if (audioRef.value) {
    try {
      await audioRef.value.play();
    } catch (error) {
      console.warn("Ringtone playback failed (may require user interaction):", error);
    }
  }
};

const stopRingingSound = () => {
  if (audioRef.value) {
    audioRef.value.pause();
    audioRef.value.currentTime = 0;
  }
};

const handleAnswerIncoming = () => {
  stopRingingSound();
  emit("answer-incoming-call");
};

const handleDeclineIncoming = () => {
  stopRingingSound();
  emit("decline-incoming-call");
};

watch(
  () => props.incomingCallData?.callState,
  (callState) => {
    if (callState === "ringing") {
      playRingingSound();
    } else {
      stopRingingSound();
    }
  },
  { immediate: true }
);

// Modal stays narrow until the call is actually picked up.
// Narrow (440px): pre-call AI prompt, briefing-loading, connecting, ringing.
// Wide  (560px):  in-call, reconnecting, incoming-call (ringing/active).
const isNarrowState = computed(() => {
  if (props.incomingCallData) return false;
  if (props.showAIPrompt || props.isPreparingAIContext) return true;
  return props.status === "connecting" || props.status === "ringing";
});
const modalWidthPx = computed(() => (isNarrowState.value ? 440 : 560));

// Header identity helpers
const contactInitials = computed(() => {
  if (!props.contactName) return "";
  const parts = props.contactName.trim().split(/\s+/).filter(Boolean).slice(0, 2);
  return parts
    .map((p) => p.charAt(0).toUpperCase())
    .join("")
    .slice(0, 2);
});

const headerSubtitle = computed(() => {
  if (props.incomingCallData) {
    return props.incomingCallData.callState === "ringing"
      ? "Incoming call"
      : `In call · ${props.formattedIncomingCallTimer}`;
  }
  if (props.isPreparingAIContext) return "Preparing AI briefing…";
  if (props.showAIPrompt) return props.to || "Call Session";
  if (props.status === "connecting") return "Connecting…";
  if (props.status === "ringing") return "Ringing…";
  if (props.status === "in-call") return `In call · ${props.formattedCallTimer}`;
  if (props.status === "reconnecting") return "Reconnecting…";
  return props.to || "Call Session";
});

const headerStatusDot = computed(() => {
  if (props.incomingCallData) {
    return props.incomingCallData.callState === "ringing" ? "is-ringing" : "is-active";
  }
  if (props.status === "in-call") return "is-active";
  if (props.status === "ringing" || props.status === "connecting") return "is-ringing";
  if (props.status === "reconnecting") return "is-warning";
  return "";
});

// ICP options for the Select component
const icpOptions = computed(() =>
  (props.icps || []).map((i: any) => ({
    value: i.id,
    label: `${i.name}${i.isDefault ? " (Default)" : ""}`,
  }))
);

// Dropdowns and Inputs
const showIVRDropdown = ref(false);
const ivrInputValue = ref("");
const showMicrophoneDropdown = ref(false);
const showTransferPopover = ref(false);
const transferTarget = ref("");
const isTransferring = ref(false);
const selectedIcpId = ref<string | undefined>(undefined);

// Trigger refs (for keypad and transfer teleported popovers)
const keypadTriggerRef = ref<HTMLElement | null>(null);
const transferTriggerRef = ref<HTMLElement | null>(null);

// Inline styles for teleported popovers
const keypadPopoverStyle = ref<Record<string, string>>({});
const transferPopoverStyle = ref<Record<string, string>>({});

const computePopoverPosition = (
  triggerEl: HTMLElement | null,
  popoverWidth: number,
  popoverHeightEstimate: number
): Record<string, string> => {
  if (!triggerEl) return {};
  const rect = triggerEl.getBoundingClientRect();
  const spacing = 12;
  const spaceAbove = rect.top;
  const spaceBelow = window.innerHeight - rect.bottom;
  const placeBelow = spaceAbove < popoverHeightEstimate + spacing && spaceBelow > spaceAbove;
  let left = rect.left + rect.width / 2 - popoverWidth / 2;
  left = Math.max(8, Math.min(left, window.innerWidth - popoverWidth - 8));
  return {
    position: "fixed",
    top: placeBelow
      ? `${rect.bottom + spacing}px`
      : `${rect.top - popoverHeightEstimate - spacing}px`,
    left: `${left}px`,
    width: `${popoverWidth}px`,
    zIndex: "20100",
  };
};

const updateKeypadPosition = () => {
  keypadPopoverStyle.value = computePopoverPosition(keypadTriggerRef.value, 240, 320);
};
const updateTransferPosition = () => {
  transferPopoverStyle.value = computePopoverPosition(transferTriggerRef.value, 300, 220);
};

watch(showIVRDropdown, async (val) => {
  if (val) {
    showMicrophoneDropdown.value = false;
    showTransferPopover.value = false;
    await nextTick();
    updateKeypadPosition();
  }
});
watch(showMicrophoneDropdown, (val) => {
  if (val) {
    showIVRDropdown.value = false;
    showTransferPopover.value = false;
  }
});
watch(showTransferPopover, async (val) => {
  if (val) {
    showIVRDropdown.value = false;
    showMicrophoneDropdown.value = false;
    await nextTick();
    updateTransferPosition();
  } else {
    transferTarget.value = "";
  }
});

const onWindowReposition = () => {
  if (showIVRDropdown.value) updateKeypadPosition();
  if (showTransferPopover.value) updateTransferPosition();
};

onMounted(() => {
  window.addEventListener("scroll", onWindowReposition, true);
  window.addEventListener("resize", onWindowReposition);
});

const isValidTransferNumber = computed(() =>
  /^\+?\d{7,15}$/.test(transferTarget.value.replace(/\s+/g, ""))
);

const onSubmitTransfer = async () => {
  if (!isValidTransferNumber.value) return;
  isTransferring.value = true;
  try {
    emit("transfer-call", transferTarget.value.replace(/\s+/g, ""));
    showTransferPopover.value = false;
    transferTarget.value = "";
  } finally {
    isTransferring.value = false;
  }
};

const onSelectMicrophone = (deviceId: string) => {
  emit("select-microphone", deviceId);
  showMicrophoneDropdown.value = false;
};

const onSelectSpeaker = (deviceId: string) => {
  emit("select-speaker", deviceId);
};

// Initialize selectedIcpId with the default ICP if available
watch(
  () => props.icps,
  (newIcps) => {
    if (newIcps && newIcps.length > 0) {
      const defaultIcp = newIcps.find((i: any) => i.isDefault) || newIcps[0];
      selectedIcpId.value = defaultIcp.id;
    }
  },
  { immediate: true }
);

const handleIVRBtn = (char: string) => {
  ivrInputValue.value += char;
  emit("send-digit", char);
};

// --- Ref and Logic for Auto-Scrolling AI Suggestions ---
const suggestionsContainer = ref<HTMLElement | null>(null);

const scrollToBottom = async () => {
  await nextTick();
  if (suggestionsContainer.value) {
    suggestionsContainer.value.scrollTop = suggestionsContainer.value.scrollHeight;
  }
};

watch(
  () => props.aiSuggestions,
  () => {
    scrollToBottom();
  },
  { deep: true }
);

watch(
  () => props.currentStreamingText,
  () => {
    if (props.currentStreamingText) {
      scrollToBottom();
    }
  }
);

// Dragging logic
const isDragging = ref(false);
const dragStart = ref({ x: 0, y: 0 });
const modalPosition = ref({ x: 0, y: 0 });
const isInitialPosition = ref(true);
const modalRef = ref<HTMLElement | null>(null);

const modalStyle = computed(() => {
  if (isInitialPosition.value) {
    return {
      width: `${modalWidthPx.value}px`,
    };
  }
  return {
    position: "fixed" as const,
    left: `${modalPosition.value.x}px`,
    top: `${modalPosition.value.y}px`,
    transform: "none",
    margin: "0",
    width: `${modalWidthPx.value}px`,
    zIndex: "20000",
  };
});

const startDrag = (event: MouseEvent | TouchEvent) => {
  const target = event.target as HTMLElement;
  const excludedSelectors = [
    ".btn-close-call",
    ".call-body",
    "a",
    "button",
    "input",
    ".keypad-popover",
    ".microphone-dropdown",
    ".transfer-popover",
    ".control-circle-btn",
    ".btn-hangup",
  ];
  if (excludedSelectors.some((selector) => target.closest(selector))) return;
  event.preventDefault();
  event.stopPropagation();
  isDragging.value = true;
  const clientX = "touches" in event ? event.touches[0].clientX : event.clientX;
  const clientY = "touches" in event ? event.touches[0].clientY : event.clientY;
  if (isInitialPosition.value) {
    const modal = modalRef.value;
    if (modal) {
      const rect = modal.getBoundingClientRect();
      modalPosition.value = { x: rect.left, y: rect.top };
    } else {
      modalPosition.value = {
        x: (window.innerWidth - modalWidthPx.value) / 2,
        y: (window.innerHeight - 500) / 2,
      };
    }
    isInitialPosition.value = false;
  }
  dragStart.value = { x: clientX - modalPosition.value.x, y: clientY - modalPosition.value.y };
  const dragEvents = [
    ["mousemove", handleDrag, { passive: false }],
    ["mouseup", stopDrag],
    ["touchmove", handleDrag, { passive: false }],
    ["touchend", stopDrag],
  ] as const;
  dragEvents.forEach(([event, handler, options]) =>
    document.addEventListener(event, handler as any, options)
  );
};

const handleDrag = (event: MouseEvent | TouchEvent) => {
  if (!isDragging.value) return;
  const clientX = "touches" in event ? event.touches[0].clientX : event.clientX;
  const clientY = "touches" in event ? event.touches[0].clientY : event.clientY;
  let newX = clientX - dragStart.value.x;
  let newY = clientY - dragStart.value.y;
  const modal = modalRef.value;
  if (modal) {
    const rect = modal.getBoundingClientRect();
    const padding = 10;
    newX = Math.max(padding, Math.min(newX, window.innerWidth - rect.width - padding));
    newY = Math.max(padding, Math.min(newY, window.innerHeight - rect.height - padding));
  }
  modalPosition.value = { x: newX, y: newY };
};

const stopDrag = () => {
  isDragging.value = false;
  ["mousemove", "mouseup", "touchmove", "touchend"].forEach((ev) =>
    document.removeEventListener(ev, handleDrag as any)
  );
};

const close = () => {
  stopRingingSound();
  if (
    activeCallStates.value.includes(props.status) ||
    props.isPreparingAIContext ||
    props.incomingCallData
  ) {
    emit("hangup");
    if (props.incomingCallData) {
      if (props.incomingCallData.callState === "ringing") emit("decline-incoming-call");
      else emit("hangup-incoming-call");
    }
  }
  isInitialPosition.value = true;
  modalPosition.value = { x: 0, y: 0 };
  emit("close");
};

const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as HTMLElement;

  if (
    showIVRDropdown.value &&
    !target.closest(".keypad-popover") &&
    target.closest(".control-circle-btn") !== keypadTriggerRef.value?.firstElementChild
  )
    showIVRDropdown.value = false;
  if (
    showTransferPopover.value &&
    !target.closest(".transfer-popover") &&
    target.closest(".control-circle-btn") !== transferTriggerRef.value?.firstElementChild
  )
    showTransferPopover.value = false;
};

onBeforeUnmount(() => {
  stopRingingSound();
  audioRef.value = null;
  ["mousemove", "mouseup", "touchmove", "touchend"].forEach((ev) =>
    document.removeEventListener(ev, handleDrag as any)
  );
  document.removeEventListener("click", handleClickOutside);
  window.removeEventListener("scroll", onWindowReposition, true);
  window.removeEventListener("resize", onWindowReposition);
});

watch(
  () => props.show,
  (val) => {
    if (val) setTimeout(() => document.addEventListener("click", handleClickOutside), 0);
    else {
      document.removeEventListener("click", handleClickOutside);
      showIVRDropdown.value = false;
      showMicrophoneDropdown.value = false;
      showTransferPopover.value = false;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal-fade" }, {
    default: _withCtx(() => [
      (__props.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["call-modal-overlay", { 'dragging-active': !isInitialPosition.value }])
          }, [
            _createElementVNode("div", {
              ref_key: "modalRef",
              ref: modalRef,
              class: _normalizeClass(["call-modal", { 'is-dragging': isDragging.value }]),
              style: _normalizeStyle(modalStyle.value),
              onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
              onMousedown: startDrag,
              onTouchstart: startDrag
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["call-header", { draggable: true }])
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    (contactInitials.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(contactInitials.value), 1))
                      : (_openBlock(), _createBlock(_unref(Icon), {
                          key: 1,
                          icon: "mdi:phone-in-talk",
                          width: "18",
                          height: "18"
                        }))
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h4", _hoisted_5, _toDisplayString(__props.contactName || __props.to || "Call Session"), 1),
                    _createElementVNode("div", _hoisted_6, [
                      (headerStatusDot.value)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["call-header-status-dot", headerStatusDot.value])
                          }, null, 2))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(headerSubtitle.value), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", _hoisted_9, [
                    _createVNode(_unref(Icon), {
                      icon: "mdi:drag",
                      width: "18",
                      height: "18"
                    })
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "header-icon-btn btn-close-call",
                    "aria-label": "Close",
                    onClick: close
                  }, [
                    _createVNode(_unref(Icon), {
                      icon: "mdi:close",
                      width: "18",
                      height: "18"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                (__props.incomingCallData && __props.incomingCallData.callState === 'ringing')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "incoming-call-indicator" }, [
                          _createElementVNode("span", { class: "pulse-dot" }),
                          _createElementVNode("span", { class: "incoming-call-text" }, "Incoming Call")
                        ], -1)),
                        _createElementVNode("div", _hoisted_13, _toDisplayString(__props.incomingCallData.from), 1)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(Button, {
                          variant: "danger",
                          style: {"flex":"1"},
                          icon: "mdi:phone-hangup",
                          onClick: handleDeclineIncoming
                        }, {
                          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                            _createTextVNode(" Decline ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(Button, {
                          variant: "success",
                          style: {"flex":"1"},
                          icon: "mdi:phone",
                          onClick: handleAnswerIncoming
                        }, {
                          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                            _createTextVNode(" Answer ", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (__props.incomingCallData && __props.incomingCallData.callState === 'active')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "active-call-indicator" }, [
                          _createElementVNode("span", { class: "active-dot" }),
                          _createElementVNode("span", { class: "active-call-text" }, "Active Call")
                        ], -1)),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(__props.formattedIncomingCallTimer), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(Button, {
                          variant: "danger",
                          style: {"flex":"1"},
                          icon: "mdi:phone-hangup",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('hangup-incoming-call')))
                        }, {
                          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                            _createTextVNode(" Hangup ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      (__props.enableTranscription && __props.incomingCallData.callSid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createVNode(LiveCaption, {
                              "is-active": true,
                              enabled: __props.enableTranscription,
                              "call-sid": __props.incomingCallData.callSid
                            }, null, 8, ["enabled", "call-sid"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (!__props.incomingCallData && (__props.showAIPrompt || __props.isPreparingAIContext))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        (__props.isPreparingAIContext)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_22, [
                                _createVNode(_unref(Icon), {
                                  icon: "mdi:robot-outline",
                                  width: "20",
                                  height: "20",
                                  class: "ai-icon"
                                }),
                                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "ai-header-title" }, "Preparing AI Briefing", -1))
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _createVNode(Spinner, {
                                  size: "md",
                                  variant: "primary"
                                }),
                                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "ai-call-prompt-loading-text" }, [
                                  _createElementVNode("p", { class: "ai-call-prompt-text muted" }, " Analyzing contact data and preparing talking points... ")
                                ], -1))
                              ])
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_24, [
                                _createVNode(_unref(Icon), {
                                  icon: "mdi:robot-outline",
                                  width: "20",
                                  height: "20",
                                  class: "ai-icon"
                                }),
                                _cache[25] || (_cache[25] = _createElementVNode("span", { class: "ai-header-title" }, "AI Call Assistant", -1))
                              ]),
                              _cache[28] || (_cache[28] = _createElementVNode("p", { class: "ai-call-prompt-text" }, " Unlock real-time strategic suggestions, talking points, and sentiment analysis during your conversation. ", -1)),
                              (__props.icps && __props.icps.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createVNode(Select, {
                                      modelValue: selectedIcpId.value,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedIcpId).value = $event)),
                                      options: icpOptions.value,
                                      label: "Target ICP",
                                      size: "md",
                                      clearable: false,
                                      "leading-icon": "mdi:bullseye-arrow"
                                    }, null, 8, ["modelValue", "options"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_26, [
                                _createVNode(Button, {
                                  variant: "primary",
                                  style: {"flex":"1"},
                                  icon: "mdi:sparkles",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('proceed-with-ai', selectedIcpId.value)))
                                }, {
                                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                    _createTextVNode(" Call with AI ", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createVNode(Button, {
                                  variant: "outline",
                                  style: {"flex":"1"},
                                  icon: "mdi:phone",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('proceed-without-ai', selectedIcpId.value)))
                                }, {
                                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                    _createTextVNode(" Call without AI ", -1)
                                  ]))]),
                                  _: 1
                                })
                              ])
                            ], 64))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (
              !__props.incomingCallData &&
              !__props.showAIPrompt &&
              !__props.isPreparingAIContext &&
              activeCallStates.value.includes(__props.status)
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createVNode(_Transition, { name: "fade-slide" }, {
                        default: _withCtx(() => [
                          (__props.hasSuggestions || __props.isThinking || __props.isStreaming)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                      _createVNode(_unref(Icon), {
                                        icon: "mdi:robot-outline",
                                        width: "16",
                                        height: "16"
                                      })
                                    ]),
                                    _cache[29] || (_cache[29] = _createElementVNode("span", { class: "suggestion-label" }, "AI SUGGESTION", -1))
                                  ])
                                ]),
                                _createElementVNode("div", {
                                  class: "ai-suggestions-list",
                                  ref_key: "suggestionsContainer",
                                  ref: suggestionsContainer
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.aiSuggestions, (suggestion, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: suggestion.id,
                                      class: _normalizeClass(["suggestion-item", {
                      'is-latest':
                        index === (__props.aiSuggestions?.length || 0) - 1 && !__props.isStreaming && !__props.isThinking,
                    }])
                                    }, [
                                      _createElementVNode("p", _hoisted_32, _toDisplayString(suggestion.text), 1)
                                    ], 2))
                                  }), 128)),
                                  (__props.isStreaming)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _createElementVNode("p", _hoisted_34, [
                                          _createTextVNode(_toDisplayString(__props.currentStreamingText), 1),
                                          _cache[30] || (_cache[30] = _createElementVNode("span", { class: "typing-cursor" }, "|", -1))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (__props.isThinking)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [...(_cache[31] || (_cache[31] = [
                                        _createElementVNode("div", { class: "thinking-loader" }, [
                                          _createElementVNode("span"),
                                          _createElementVNode("span"),
                                          _createElementVNode("span")
                                        ], -1)
                                      ]))]))
                                    : _createCommentVNode("", true)
                                ], 512)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (__props.enableTranscription)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createVNode(LiveCaption, {
                              "is-active": true,
                              enabled: __props.enableTranscription,
                              "call-sid": __props.parentCallSid || __props.currentCallSid
                            }, null, 8, ["enabled", "call-sid"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(Button, {
                            rounded: "",
                            variant: "danger",
                            icon: "mdi:phone-hangup",
                            class: "control-circle-btn",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('hangup')))
                          }),
                          _cache[32] || (_cache[32] = _createElementVNode("span", { class: "control-label-original" }, "Hang up", -1))
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["control-item-original", { active: __props.account?.allowCallRecording && __props.saveRecording }])
                        }, [
                          _createVNode(Button, {
                            rounded: "",
                            variant: __props.account?.allowCallRecording && __props.saveRecording ? 'danger' : 'outline',
                            icon: "mdi:record-circle-outline",
                            class: "control-circle-btn",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('toggle-record')))
                          }, null, 8, ["variant"]),
                          _cache[33] || (_cache[33] = _createElementVNode("span", { class: "control-label-original" }, "Record", -1))
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["control-item-original", { active: __props.isMuted }])
                        }, [
                          _createVNode(Button, {
                            rounded: "",
                            variant: __props.isMuted ? 'primary' : 'outline',
                            icon: __props.isMuted ? 'mdi:microphone-off' : 'mdi:microphone',
                            class: "control-circle-btn",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('toggle-mute')))
                          }, null, 8, ["variant", "icon"]),
                          _cache[34] || (_cache[34] = _createElementVNode("span", { class: "control-label-original" }, "Mute", -1))
                        ], 2),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", {
                            ref_key: "keypadTriggerRef",
                            ref: keypadTriggerRef
                          }, [
                            _createVNode(Button, {
                              rounded: "",
                              variant: showIVRDropdown.value ? 'primary' : 'outline',
                              icon: "mdi:dialpad",
                              class: "control-circle-btn",
                              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (showIVRDropdown.value = !showIVRDropdown.value), ["stop"]))
                            }, null, 8, ["variant"])
                          ], 512),
                          _cache[35] || (_cache[35] = _createElementVNode("span", { class: "control-label-original" }, "Keypad", -1))
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _createVNode(Button, {
                            rounded: "",
                            variant: showMicrophoneDropdown.value ? 'primary' : 'outline',
                            icon: "mdi:volume-high",
                            class: "control-circle-btn",
                            onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (showMicrophoneDropdown.value = !showMicrophoneDropdown.value), ["stop"]))
                          }, null, 8, ["variant"]),
                          _cache[37] || (_cache[37] = _createElementVNode("span", { class: "control-label-original" }, "Audio", -1)),
                          (showMicrophoneDropdown.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "microphone-dropdown",
                                onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _cache[36] || (_cache[36] = _createElementVNode("div", { class: "dropdown-header" }, "Select Microphone", -1)),
                                _createElementVNode("ul", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.microphones, (mic) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: mic.deviceId,
                                      onClick: ($event: any) => (onSelectMicrophone(mic.deviceId))
                                    }, _toDisplayString(mic.label), 9, _hoisted_41))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", {
                            ref_key: "transferTriggerRef",
                            ref: transferTriggerRef
                          }, [
                            _createVNode(Button, {
                              rounded: "",
                              variant: showTransferPopover.value ? 'primary' : 'outline',
                              icon: "mdi:phone-forward",
                              class: "control-circle-btn",
                              onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (showTransferPopover.value = !showTransferPopover.value), ["stop"]))
                            }, null, 8, ["variant"])
                          ], 512),
                          _cache[38] || (_cache[38] = _createElementVNode("span", { class: "control-label-original" }, "Transfer", -1))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 38),
            (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
              (showIVRDropdown.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "keypad-popover",
                    style: _normalizeStyle(keypadPopoverStyle.value),
                    onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createVNode(Button, {
                      variant: "ghost",
                      size: "xs",
                      icon: "mdi:close",
                      style: {"position":"absolute","top":"8px","right":"8px"},
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (showIVRDropdown.value = false))
                    }),
                    _createElementVNode("div", _hoisted_43, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((ivrInputValue).value = $event)),
                        placeholder: "Enter digits",
                        class: "keypad-input",
                        autocomplete: "off"
                      }, null, 512), [
                        [_vModelText, ivrInputValue.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'], (num) => {
                        return _createVNode(Button, {
                          key: num,
                          variant: "outline",
                          style: {"height":"44px","width":"100%","font-weight":"700"},
                          onClick: ($event: any) => (handleIVRBtn(num))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(num), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      }), 64))
                    ])
                  ], 4))
                : _createCommentVNode("", true)
            ])),
            (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
              (showTransferPopover.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "transfer-popover",
                    style: _normalizeStyle(transferPopoverStyle.value),
                    onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("div", _hoisted_45, [
                      _cache[39] || (_cache[39] = _createElementVNode("span", { class: "transfer-popover__title" }, "Transfer call", -1)),
                      _createVNode(Button, {
                        variant: "ghost",
                        size: "xs",
                        icon: "mdi:close",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (showTransferPopover.value = false))
                      })
                    ]),
                    _cache[41] || (_cache[41] = _createElementVNode("p", { class: "transfer-popover__hint" }, " Forward this call to another number. The call will continue with that party and your line will end. ", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((transferTarget).value = $event)),
                      class: "transfer-popover__input",
                      placeholder: "+15551234567",
                      autocomplete: "off",
                      onKeydown: _withKeys(onSubmitTransfer, ["enter"])
                    }, null, 544), [
                      [_vModelText, transferTarget.value]
                    ]),
                    _createVNode(Button, {
                      variant: "primary",
                      disabled: !isValidTransferNumber.value,
                      loading: isTransferring.value,
                      style: {"width":"100%","margin-top":"12px"},
                      onClick: onSubmitTransfer
                    }, {
                      default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                        _createTextVNode(" Transfer ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "loading"])
                  ], 4))
                : _createCommentVNode("", true)
            ]))
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})